"use client";

import { Box, Flex, Skeleton } from "@chakra-ui/react";
import { useThemeTokens } from "@/lib/theme/tokens";

interface ClassSinglePageSkeletonProps {
  isInDashboard?: boolean;
}

export const ClassSinglePageSkeleton = ({
  isInDashboard = false,
}: ClassSinglePageSkeletonProps) => {
  const theme = useThemeTokens();

  return (
    <Flex direction="column" maxW="720px" mx="auto" w="100%" pb={isInDashboard ? undefined : { base: 20, md: 0 }}>
      <Skeleton height="20px" width="160px" mb={6} borderRadius="4px" />

      <Skeleton
        w="100%"
        height={{ base: "200px", md: "280px" }}
        borderRadius="12px"
        mb={6}
      />

      <Box pb={6} borderBottomWidth="1px" borderColor={theme.borderGlass.subtle}>
        <Skeleton height="12px" width="88px" mb={3} borderRadius="4px" />
        <Skeleton height={{ base: "34px", md: "42px" }} width="85%" mb={4} borderRadius="6px" />
        <Skeleton height="12px" width="72px" mb={2} borderRadius="4px" />
        <Skeleton height="16px" width="140px" mb={4} borderRadius="4px" />
        <Skeleton height="16px" width="95%" mb={5} borderRadius="4px" />
        {!isInDashboard && (
          <Flex gap={3}>
            <Skeleton height="36px" width="120px" borderRadius="8px" />
            <Skeleton height="36px" width="88px" borderRadius="8px" />
          </Flex>
        )}
      </Box>

      <Box py={6} borderBottomWidth="1px" borderColor={theme.borderGlass.subtle}>
        <Flex direction="column" gap={2}>
          <Skeleton height="16px" width="100%" borderRadius="4px" />
          <Skeleton height="16px" width="100%" borderRadius="4px" />
          <Skeleton height="16px" width="92%" borderRadius="4px" />
        </Flex>
      </Box>

      <Box pt={3}>
        <Skeleton height="12px" width="72px" mb={4} borderRadius="4px" />
        {[1, 2].map((i) => (
          <Flex
            key={i}
            justify="space-between"
            align="center"
            py={4}
            borderTopWidth={i === 1 ? "1px" : 0}
            borderBottomWidth="1px"
            borderColor={theme.borderGlass.subtle}
          >
            <Box flex={1}>
              <Skeleton height="12px" width="64px" mb={2} borderRadius="4px" />
              <Skeleton height="16px" width="140px" borderRadius="4px" />
            </Box>
            <Skeleton boxSize="16px" borderRadius="4px" />
          </Flex>
        ))}
      </Box>
    </Flex>
  );
};
